module.exports = __webpack_public_path__ + "static/Majesti-Heavy-8e599ee16778a200d0aee8dafae3e343.otf";